import { SettingLineLight } from '@profgeosoft-ui/icons';
import clsx from 'clsx';
import { observer } from 'mobx-react-lite';
import type { ReactNode } from 'react';
import { useMemo } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import BellIcon from 'src/shared/assets/icons/bell.svg';
import EarphonesIcon from 'src/shared/assets/icons/earphones.svg';
import InfoIcon from 'src/shared/assets/icons/info.svg';
import { ROUTES } from 'src/shared/constants/routes';
import { useStore } from 'src/store';

import { MenuItem } from '../menu-item/menu-item';

import styles from './styles.module.scss';

type Props = {
  isOpened: boolean;
};

export const Support: React.FC<Props> = observer(function Support({ isOpened }) {
  const { theme } = useStore();
  const navigate = useNavigate();
  const location = useLocation();

  const supportItems = useMemo<
    {
      name: string;
      renderIcon: (className: string) => ReactNode;
      onClick?: () => void;
      notifications?: { count: number };
      to?: string;
    }[]
  >(
    () => [
      {
        name: 'Nav.support',
        renderIcon: (className: string) => <EarphonesIcon className={className} />,
        onClick: () => {},
      },
      {
        name: 'Nav.help',
        renderIcon: (className: string) => <InfoIcon className={className} />,
        onClick: () => {},
      },
      {
        name: 'Nav.notifications',
        renderIcon: (className: string) => <BellIcon className={className} />,
        notifications: {
          count: 1123,
        },
        onClick: () => {},
      },
      {
        // TODO: localization
        name: 'Системные настройки',
        to: ROUTES.settings,
        renderIcon: (_: string, isActive?: boolean) => (
          <SettingLineLight
            className={clsx(styles.icon, isActive && styles.icon__active, theme.theme === 'dark' && styles.icon__dark)}
          />
        ),
      },
    ],
    [theme.theme],
  );

  return (
    <div className={clsx(styles.wrapper, isOpened && styles.wrapper__opened)}>
      {supportItems.map((sup) => {
        const to = sup.to ?? null;

        if (!to) {
          return <MenuItem key={sup.name} isOpened={isOpened} item={sup} onClick={sup.onClick} />;
        }

        const isActive = location.pathname.includes(to.replaceAll(/[*/]/g, ''));
        const onClick = () => navigate(to);

        return <MenuItem key={sup.name} isActive={isActive} isOpened={isOpened} item={sup} onClick={onClick} />;
      })}
    </div>
  );
});
